import {
  Directive,
  ElementRef,
  OnInit,
  AfterContentInit,
  AfterViewInit,
} from '@angular/core';

@Directive({
    selector: '[inputAutoFocus]',
    standalone: false
})
export class AutoFocusDirective implements OnInit {

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.elementRef.nativeElement.focus();
  }

}
